/* eslint-disable @typescript-eslint/no-explicit-any */
// Notificaciones (iNotifications) contra el GraphQL de masterws. Usa variables, no texto pegado en la query.
// Client y Type aceptan varios valores (clientIds / actions): varios valores = OR.
import * as url from './url_helper';

// Consultas en curso: el botón Stop las corta (detenerConsultas). El servidor termina su consulta igual,
// pero la pantalla deja de esperarla. Una consulta cortada falla con error.stopped = true.
const enCurso = new Set<AbortController>();
const gql = async (query: string, variables: any = {}) => {
  const control = new AbortController();
  enCurso.add(control);
  try {
    const r = await fetch(url.API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, variables }),
      signal: control.signal,
    }).then((x) => x.json());
    if (r?.errors?.length) throw new Error(r.errors[0].message);
    return r?.data || {};
  } catch (e: any) {
    if (e?.name === 'AbortError') throw Object.assign(new Error('Stopped'), { stopped: true });
    throw e;
  } finally {
    enCurso.delete(control);
  }
};
export const detenerConsultas = () => {
  enCurso.forEach((c) => c.abort());
  enCurso.clear();
};

const lista = (v: any): string[] => (Array.isArray(v) ? v : v ? [v] : []).map(String).filter(Boolean);
const ids = (v: any): number[] => lista(v).map(Number).filter((n) => Number.isInteger(n) && n > 0);

export const getNotifications = async ({ pagination, filters, order }: any) => {
  const f: any = {
    initial_date: filters.from || null,
    final_date: filters.to || null,
    order,
    status: filters.status || null,
    search: filters.search || null,
  };
  const clientes = ids(filters.clientId);
  if (clientes.length) f.clientIds = clientes;
  const acciones = lista(filters.action);
  if (acciones.length) f.actions = acciones;
  if (filters.fallback === 'yes') f.fallback = true;
  if (filters.fallback === 'no') f.fallback = false;
  const data = await gql(
    `query ($filters: INotificationsFiltersInput, $p: INotificationsPagination!) {
      GetNotifications(filters: $filters, Pagination: $p) {
        CountItems
        listData { id clientId clientName taskId number action fromAddress via fallback toAddresses subject status error sentAt createdAt }
      }
    }`,
    { filters: f, p: { sizePage: pagination.sizePerPage, actualPage: pagination.page } },
  );
  return data.GetNotifications || { listData: [], CountItems: 0 };
};

// Opciones del rango: clientes con correos en el rango y tipos (acotados a los clientes elegidos).
export const getNotificationFilters = async ({ from, to, clientIds }: any = {}) => {
  const clientes = ids(clientIds);
  const data = await gql(
    `query ($filters: INotificationsFiltersInput) { GetNotificationFilters(filters: $filters) { clients { id name } actions } }`,
    { filters: { initial_date: from || null, final_date: to || null, ...(clientes.length ? { clientIds: clientes } : {}) } },
  );
  return data.GetNotificationFilters || { clients: [], actions: [] };
};

export const getNotificationHtml = async (id: number) => {
  const data = await gql(`query ($id: Int!) { GetNotificationHtml(id: $id) }`, { id });
  return data.GetNotificationHtml || null;
};
